module.exports = __webpack_public_path__ + "static/media/province100.4b03de5d.png";